// pp-calc-volumetrico.js — Peso Volumétrico y Medidas Máximas por Paquetería
// (/pages/calculadora-peso-volumetrico)
//
// Dos respuestas en una: (1) qué peso te van a COBRAR (el mayor entre real y
// volumétrico), y (2) si tu paquete PASA en cada paquetería o le cae recargo
// por sobredimensión — el verificador que ninguna calculadora en español da.
//
// ── DE DÓNDE SALEN LAS REGLAS (consultadas el 31-ago-2026) ────────────────
// NO inventadas: recopiladas de las fuentes de cada paquetería ese día.
// Al año, re-verificarlas (las tarifas cambian cada enero).
//
// ESTAFETA (oficial, estafeta.com — Servicios Complementarios y Mensajería
//   Nacional): divisor 5000; paquete regular hasta 100×100×100 cm; lado
//   >100 cm = "no manejable por banda" $180+IVA; embalaje mayor hasta
//   150×115×115 y 70 kg; tarifa de lista hasta 31.5 kg, después kilo
//   excedente; techo operativo de paquete ~68-70 kg.
// FEDEX MX (oficial, Guía de Servicios y Tarifas 2026, tarifas 5-ene-2026):
//   divisor 5000 (redondeo al kg superior); manejo adicional si lado >121,
//   2º lado >76, contorno (largo+2·ancho+2·alto) >266 cm, volumen >169,901
//   cm³ o peso >25 kg; extragrande si largo >243, contorno >330, volumen
//   >283,168 cm³ o peso >50 kg ($715.50); >68 kg ya es carga (Embarques
//   Pesados).
// DHL EXPRESS MX (oficial, T&C de transporte + página de recargos 2026):
//   divisor 5000; recargo tamaño si lado >100 o 2º lado >80 ($365.98/pza
//   doméstico); recargo sobrepeso si peso real O volumétrico >70 kg
//   ($349.74/pza; no se acumulan). Tope absoluto NO publicado.
// PAQUETEXPRESS (clausulado oficial): cobra el mayor entre físico y
//   volumétrico SIN publicar divisor (agregadores reportan 5000); "grandes
//   dimensiones" = largo >300 / ancho >200 / alto >180 → consultar. Guías
//   prepagadas oficiales llegan a 30 kg (50×42×36).
// 99MINUTOS (oficial, developers.99minutos.com): máximo 70×70×70 cm y
//   25 kg en México; excedido = RECHAZAN el envío. Sin divisor publicado.
// ──────────────────────────────────────────────────────────────────────────
//
// Aritmética pura probada en tests/calculadoras-logica.test.mjs.
(function (root) {
  'use strict';

  var DIVISOR = 5000; // confirmado oficial para Estafeta, FedEx y DHL

  // Entradas en cm y kg. Devuelve null si faltan datos.
  function evaluar(e) {
    if (!e) return null;
    var l = num(e.largoCm), w = num(e.anchoCm), h = num(e.altoCm), peso = num(e.pesoKg);
    if ([l, w, h, peso].some(function (v) { return v === null || v <= 0; })) return null;

    var d = [l, w, h].sort(function (a, b) { return b - a; }); // [mayor, medio, menor]
    var volumen = l * w * h;
    var pesoVol = volumen / DIVISOR;
    var facturable = Math.max(peso, pesoVol);
    var contorno = d[0] + 2 * d[1] + 2 * d[2]; // "girth" FedEx: largo + 2·ancho + 2·alto

    var estafeta;
    if (d[0] <= 100 && d[1] <= 100 && d[2] <= 100 && peso <= 70) {
      estafeta = { estado: 'ok', motivos: peso > 31.5 ? ['kilo_excedente'] : [] };
    } else if (d[0] <= 150 && d[1] <= 115 && d[2] <= 115 && peso <= 70) {
      estafeta = { estado: 'recargo', motivos: ['no_banda'] };
    } else {
      estafeta = { estado: 'carga', motivos: [] };
    }

    var fedex;
    if (peso > 68) {
      fedex = { estado: 'carga', motivos: [] };
    } else if (d[0] > 243 || contorno > 330 || volumen > 283168 || peso > 50) {
      fedex = { estado: 'recargo', motivos: ['extragrande'] };
    } else if (d[0] > 121 || d[1] > 76 || contorno > 266 || volumen > 169901 || peso > 25) {
      fedex = { estado: 'recargo', motivos: ['manejo_adicional'] };
    } else {
      fedex = { estado: 'ok', motivos: [] };
    }

    var dhl = { estado: 'ok', motivos: [] };
    if (d[0] > 100 || d[1] > 80) dhl.motivos.push('tamano');
    if (peso > 70 || pesoVol > 70) dhl.motivos.push('sobrepeso');
    if (dhl.motivos.length) dhl.estado = 'recargo';

    var px;
    if (d[0] > 300 || d[1] > 200 || d[2] > 180) {
      px = { estado: 'consulta', motivos: ['grandes_dimensiones'] };
    } else {
      px = { estado: 'ok', motivos: ['limites_no_publicados'] };
    }

    var n99;
    if (d[0] > 70 || peso > 25) {
      n99 = { estado: 'rechazo', motivos: [] };
    } else {
      n99 = { estado: 'ok', motivos: [] };
    }

    return {
      pesoVolumetrico: pesoVol,
      facturable: facturable,
      cobraVolumen: pesoVol > peso,
      contorno: contorno,
      paqueterias: { estafeta: estafeta, fedex: fedex, dhl: dhl, paquetexpress: px, n99: n99 }
    };
  }

  function num(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcVolumetrico = {
    DIVISOR: DIVISOR,
    evaluar: evaluar
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-volumetrico]');
    if (!raiz) return;
    var C = window.PPCalcVolumetrico;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    function telemetria(inputs, resultado) {
      try {
        var KEY = 'sb_publishable_48y6S7h2eQ-9uTF7pCNJNQ_Q0mz8VVX';
        fetch('https://dhygbnysealeblqorjts.supabase.co/functions/v1/calc-telemetria', {
          method: 'POST',
          keepalive: true,
          headers: { 'Content-Type': 'application/json', 'apikey': KEY, 'Authorization': 'Bearer ' + KEY },
          body: JSON.stringify({ calculadora: 'volumetrico', inputs: inputs, resultado: resultado })
        }).catch(function () {});
      } catch (_) { /* la telemetría jamás rompe la calculadora */ }
    }

    function fmt(n, dec) {
      return n.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 1 : dec });
    }

    // Textos de la tabla de paqueterías. Los montos vienen de las fuentes del
    // encabezado de este archivo (consultadas 31-ago-2026).
    var CHIPS = {
      ok: { clase: 'ok', texto: 'Pasa' },
      recargo: { clase: 'alerta', texto: 'Con recargo' },
      carga: { clase: 'rojo', texto: 'Ya no es paquete' },
      rechazo: { clase: 'rojo', texto: 'Lo rechazan' },
      consulta: { clase: 'gris', texto: 'A consultar' }
    };
    var MOTIVOS = {
      kilo_excedente: 'Arriba de 31.5 kg pagas kilo excedente sobre la tarifa de lista.',
      no_banda: 'Un lado pasa de 100 cm: "no manejable por banda", $180 + IVA (embalaje mayor, hasta 150×115×115 y 70 kg).',
      extragrande: 'Paquete extragrande (largo >243 cm, contorno >330 cm, >283 mil cm³ o >50 kg): $715.50 por envío.',
      manejo_adicional: 'Cargo por manejo adicional (lado >121 cm, 2º lado >76 cm, contorno >266 cm, >169 mil cm³ o >25 kg): $170.50–$348.50 según servicio.',
      tamano: 'Pieza excedida de tamaño (lado >100 cm o 2º lado >80 cm): $365.98 por pieza.',
      sobrepeso: 'Pieza con sobrepeso (peso real o volumétrico >70 kg): $349.74 por pieza.',
      grandes_dimensiones: 'Pasa sus "grandes dimensiones" (300/200/180 cm): disponibilidad a consultar.',
      limites_no_publicados: 'Paquetexpress no publica límites del servicio estándar; sus guías prepagadas llegan a 30 kg.'
    };
    var NOMBRES = { estafeta: 'Estafeta', fedex: 'FedEx', dhl: 'DHL Express', paquetexpress: 'Paquetexpress', n99: '99minutos' };

    function correr(conTelemetria) {
      var f = new FormData(form);
      var datos = { largoCm: f.get('largo'), anchoCm: f.get('ancho'), altoCm: f.get('alto'), pesoKg: f.get('peso') };
      var r = C.evaluar(datos);
      pintar(r);
      if (conTelemetria && r) {
        telemetria(
          { largo_cm: Number(datos.largoCm) || null, ancho_cm: Number(datos.anchoCm) || null, alto_cm: Number(datos.altoCm) || null, peso_kg: Number(datos.pesoKg) || null },
          { peso_volumetrico_kg: Math.round(r.pesoVolumetrico * 10) / 10, facturable_kg: Math.round(r.facturable * 10) / 10 }
        );
      }
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: las tres medidas y el peso deben ser mayores a cero.</p>';
        return;
      }
      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--' + (r.cobraVolumen ? 'alerta' : 'ok') + '">';
      html += '<p class="pp-calc__veredicto-titulo">Te cobran por ' + fmt(r.facturable) + ' kg</p>';
      if (r.cobraVolumen) {
        html += '<p class="pp-calc__veredicto-dato">Tu paquete "pesa" más por volumen que en la báscula: volumétrico <strong>' + fmt(r.pesoVolumetrico) + ' kg</strong> (medidas ÷ 5,000) contra el peso real. Estás pagando por aire — una caja más justa lo baja.</p>';
      } else {
        html += '<p class="pp-calc__veredicto-dato">Manda el peso real: el volumétrico salió en ' + fmt(r.pesoVolumetrico) + ' kg, abajo de tu peso de báscula.</p>';
      }
      html += '</div>';

      html += '<dl class="pp-calc__detalle">';
      var orden = ['estafeta', 'fedex', 'dhl', 'paquetexpress', 'n99'];
      for (var i = 0; i < orden.length; i++) {
        var k = orden[i];
        var p = r.paqueterias[k];
        var chip = CHIPS[p.estado];
        html += '<div class="pp-calc__detalle-fila"><dt><strong>' + NOMBRES[k] + '</strong>';
        for (var m = 0; m < p.motivos.length; m++) {
          html += '<span class="pp-calc__motivo">' + MOTIVOS[p.motivos[m]] + '</span>';
        }
        html += '</dt><dd><span class="pp-calc__chip pp-calc__chip--' + chip.clase + '">' + chip.texto + '</span></dd></div>';
      }
      html += '</dl>';
      html += '<p class="pp-calc__nota">Reglas y montos recopilados de las fuentes de cada paquetería el 31-ago-2026 (tarifas 2026). Las paqueterías las cambian cada año — confirma con la tuya antes de un envío crítico.</p>';
      out.innerHTML = html;
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr(true);
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(false); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
